import { createQueryKeys } from '@lukemorales/query-key-factory'

/**
 * Query keys for business notes
 */
export const notes = createQueryKeys('notes', {
  lists: (params: { referralShareId?: number; leadInquiryId?: number }) => [params],
  list: (filters: { referralShareId?: number; leadInquiryId?: number }) => ({
    queryKey: [filters],
    queryFn: () => null, // This will be provided when used
  }),
  details: (id: number) => [id],
})
